import './WorkOrderGrid.scss';
import {
    Column,
    Item,
    Lookup
} from 'devextreme-react/data-grid';

import { useGetWorkOrders } from "../api/get-work-orders";
import { WorkOrderGridProps } from '../types/WorkOrderGridProps';
import { useGetOrderStatuses } from '../../../../api/lookup';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { ClosedOrdersControl } from '../../../common';
import OrderTypeSelector from '../../order-type-selector/components/OrderTypeSelector';

export default function WorkOrderGrid(props: WorkOrderGridProps) {

    let [closedOrdersState, setClosedOrdersState] = useState<{ closedOrders: boolean, dateFrom: Date | null }>
        ({ closedOrders: false, dateFrom: null });

    const orders = useGetWorkOrders(closedOrdersState.closedOrders, closedOrdersState.dateFrom);
    const orderStatuses = useGetOrderStatuses();

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    return (
        <div className='dx-card wide-card'>
            <OrderTypeSelector />

            <SyncDataGrid
                stateStorageKey='work-order-grid'
                dataSource={orders.data}
                keyExpr={'workOrderID'}
                height="60vh"
                additionalToolbarItems={[
                    <Item
                        location={'before'}
                        key="closed-orders"
                    >
                        <ClosedOrdersControl
                            onClosedOrdersChanged={(e) => {
                                setClosedOrdersState({ closedOrders: e.checked, dateFrom: e.dateFrom })
                            }}
                        />
                    </Item>
                ]}
            >
                <Column
                    dataField={'woNumber'}
                    caption={'Work Order #'}
                    dataType="string"
                    cellRender={(cell: any) => {
                        return <Link to={`/cfi/work-order/${cell.data.workOrderID}?returnUrl=${returnUrl}`}>
                            {cell.data.woNumber}
                        </Link>;
                    }}
                />
                <Column
                    dataField={'woDate'}
                    caption={'Customer Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'dealerNumber'}
                    caption={'Store #'}
                    dataType="string"
                />
                <Column
                    dataField={'orderStatus'}
                    caption={'Order Status'}
                    dataType="string"
                >
                    <Lookup
                        dataSource={orderStatuses.data}
                        valueExpr={'description'}
                        displayExpr={'description'}
                    />
                </Column>
                <Column
                    dataField={'originatingRO'}
                    caption={'Retail Order #'}
                    dataType="string"
                />
                <Column
                    dataField={'projectNumber'}
                    caption={'Project #'}
                    dataType="string"
                />
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'customerName'}
                    caption={'Customer Name'}
                    dataType="string"
                />
                <Column
                    dataField={'customerAddress'}
                    caption={'Customer Address'}
                    dataType="string"
                />
                <Column
                    dataField={'customerPhone'}
                    caption={'Customer Phone #'}
                    dataType="string"
                />
                <Column
                    dataField={'customerEmail'}
                    caption={'Customer Email'}
                    dataType="string"
                />
                <Column
                    dataField={'customerCityZip'}
                    caption={'City/State,Zip'}
                    dataType="string"
                />
            </SyncDataGrid>

            <LoadPagePanel visible={orders.isLoading} />

        </div>
    )
} 
